import { type FC, useCallback, useState } from 'react'

import { F0Box, F0Heading, F0Icon, F0Text } from '@factorialco/f0-react'
import { ChevronDown, ChevronUp } from '@factorialco/f0-react/icons/app'

export type FAQItem = {
  id: string
  question: string
  answer: string
}

export type MarketplaceFAQProps = {
  title: string
  items: FAQItem[]
}

export const MarketplaceFAQ: FC<MarketplaceFAQProps> = ({ title, items }) => {
  const [openIds, setOpenIds] = useState<Set<string>>(new Set())

  const toggle = useCallback((id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }, [])

  if (items.length === 0) return null

  return (
    <F0Box flexDirection="column" gap="sm">
      <F0Heading variant="heading" content={title} />

      <F0Box flexDirection="column">
        {items.map((item) => {
          const isOpen = openIds.has(item.id)

          return (
            <F0Box
              key={item.id}
              flexDirection="column"
              borderBottom="default"
              paddingY="md"
            >
              <div className="cursor-pointer" onClick={() => toggle(item.id)}>
                <div className="flex flex-row justify-between items-center py-1">
                  <div className="flex-1 min-w-0">
                    <F0Text variant="label" content={item.question} />
                  </div>
                  <div className="flex-shrink-0 ml-2">
                    <F0Icon icon={isOpen ? ChevronUp : ChevronDown} size="md" />
                  </div>
                </div>
              </div>

              {isOpen && (
                <F0Box paddingTop="sm">
                  <F0Text variant="body" content={item.answer} />
                </F0Box>
              )}
            </F0Box>
          )
        })}
      </F0Box>
    </F0Box>
  )
}
